"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToConcentrationLimitReceivables = void 0;
const progressHelper_1 = require("./progressHelper");
const receivableBorrowingBaseTestWaivers_1 = require("./receivableBorrowingBaseTestWaivers");
const convertToConcentrationLimitReceivables = ({ creditFacilityReceivables, calcAgentMechanics, progressCallback, receivableWaivers, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const concentrationLimitReceivables = [];
    const groupedReceivableWaiversByFinleyReceivableId = (0, receivableBorrowingBaseTestWaivers_1.groupReceivableBorrowingBaseTestWaivers)({ receivableBorrowingBaseTestWaivers: receivableWaivers });
    const { updateProgress } = (0, progressHelper_1.createProgressHelper)({
        operation: 'Evaluate eligibility criteria',
        progressCallback,
        numRows: creditFacilityReceivables.length,
    });
    // We use a "for" loop here instead of "map" to allow for progress updates
    let progressIndex = 0;
    for (const creditFacilityReceivable of creditFacilityReceivables) {
        // eslint-disable-next-line no-await-in-loop, no-plusplus
        yield updateProgress(progressIndex++);
        const concentrationLimitReceivable = Object.assign(Object.assign({}, creditFacilityReceivable), { valuationFields: {
                valuation: 0,
                valuationRate: 0,
            }, eligibilityStatuses: [], eligibilityFields: {
                eligibilityKickout: 0,
                eligibleExposure: 0,
                isEligible: true,
            }, concentrationLimitFields: {
                eligibleExposureLessConcentrationLimitKickouts: 0,
            }, concentrationLimitReasons: [], concentrationLimitWaivers: [] });
        // Run ValuationRate and set for target receivable
        const valuationBaseFields = calcAgentMechanics.evaluateValuationRate(creditFacilityReceivable);
        concentrationLimitReceivable.valuationFields = valuationBaseFields;
        const waivedEligibilityTestKeysForReceivable = (_a = groupedReceivableWaiversByFinleyReceivableId[creditFacilityReceivable.finleyReceivableId]) !== null && _a !== void 0 ? _a : new Set();
        // Run Eligibility + exposure and set for target receivable
        const { isEligible, eligibilityStatuses, } = calcAgentMechanics.evaluateEligibility({
            valuationReceivable: concentrationLimitReceivable,
            waivedEligibilityTestKeysForReceivable,
        });
        const eligibleExposure = isEligible ? valuationBaseFields.valuation : 0;
        const eligibilityKickout = isEligible ? 0 : valuationBaseFields.valuation;
        concentrationLimitReceivable.eligibilityStatuses = eligibilityStatuses;
        concentrationLimitReceivable.eligibilityFields = {
            isEligible,
            eligibleExposure,
            eligibilityKickout,
        };
        concentrationLimitReceivable.concentrationLimitFields = {
            eligibleExposureLessConcentrationLimitKickouts: eligibleExposure,
        };
        // Add new receivable object to resulting array
        concentrationLimitReceivables.push(concentrationLimitReceivable);
    }
    return concentrationLimitReceivables;
});
exports.convertToConcentrationLimitReceivables = convertToConcentrationLimitReceivables;
//# sourceMappingURL=convertToConcentrationLimitReceivables.js.map